<div class="memberships-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'"
     [class.page-loaded]="isPageLoaded"
     [style.background-color]="getMembershipPlansBackgroundColor()">
  
  <!-- Header Section -->
  <div class="website-element header-element" 
       *ngIf="isSectionVisible('header')"
       [class.selected]="getHeaderElement()?.selected"
       (click)="onHeaderClick($event)">
    <app-champs-page-header
      [logo]="getHeaderLogo()"
      [navigation]="getHeaderNavigation()"
      [ctaButton]="getHeaderCTAButton()"
      [visible]="true"
      [clickable]="true"
      [selected]="getHeaderElement()?.selected || false"
      [headingColor]="headingColor"
      [headingFont]="headingFont"
      [backgroundColor]="getHeaderBackgroundColor()"
      [deviceType]="deviceType"
      (navigationClick)="onNavigationClick($event)">
    </app-champs-page-header>
  </div>

  <!-- Hero Section with Title and Subtitle -->
  <section 
    class="hero-section website-element" 
    *ngIf="isSectionVisible('membership_plans_section')"
    [class.selected]="getMembershipPlansElement()?.selected"
    (click)="onMembershipPlansSectionClick($event)">
    <div class="hero-content">
      <h1 class="hero-title"
          [style.color]="getMembershipPlansTitleColor()"
          [style.font-family]="getHeadingFont()"
          [ngStyle]="getMembershipPlansTitleStyles()">
        {{ getMembershipPlansTitle() }}
      </h1>
      <p class="hero-subtitle"
         [style.color]="getMembershipPlansSubtitleColor()"
         [style.font-family]="getBodyFont()">
        {{ getMembershipPlansSubtitle() }}
      </p>
    </div>
  </section>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading membership plans...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-state">
    <p>{{ error }}</p>
  </div>

  <!-- Membership Plans Cards Section -->
  <section 
    class="membership-plans-section website-element" 
    *ngIf="isSectionVisible('membership_plans_section') && !loading && !error && membershipPlans.length > 0"
    [class.selected]="getMembershipPlansElement()?.selected"
    (click)="onMembershipPlansSectionClick($event)">
    <div class="plans-container">
      <div class="plans-grid">
        <app-champs-membership-card
             *ngFor="let plan of membershipPlans; let i = index; trackBy: trackByIndex"
             [plan]="plan"
             [index]="i"
             [primaryColor]="primaryColor"
             [headingColor]="headingColor"
             [paragraphColor]="paragraphColor"
             [headingFont]="headingFont"
             [bodyFont]="bodyFont"
             [planName]="getPlanName(plan)"
             [planPrice]="getPlanPrice(plan)"
             [planDescription]="getPlanDescription(plan)"
             [featuresTitle]="getFeaturesTitle(plan, i)"
             [features]="getPlanFeatures(plan)"
             [buttonLabel]="getButtonLabel()"
             [colorClass]="getPlanColorClass(plan, i)"
             [showPopularBadge]="false"
             (buyClick)="onBuyNowClick($event.plan, $event.event)">
        </app-champs-membership-card>
      </div>
    </div>
  </section>

  <!-- Comparison Table Section -->
  <section 
    class="comparison-section website-element" 
    *ngIf="isSectionVisible('comparison_section') && comparisonData"
    [class.selected]="getComparisonElement()?.selected"
    (click)="onComparisonSectionClick($event)">
    <div class="comparison-container">
      <!-- Scrollable Wrapper for Title, Header Buttons, and Table -->
      <div class="comparison-scroll-wrapper"
           (mousedown)="$event.stopPropagation()"
           (touchstart)="$event.stopPropagation()">
        <!-- Title and Header Buttons Row -->
        <div class="comparison-title-header-row">
          <h2 class="comparison-title"
              [style.color]="getHeadingColor()"
              [style.font-family]="getHeadingFont()">
            {{ getComparisonTitle() }}
          </h2>
          <div class="comparison-header-buttons">
            <div class="plan-header-cell" *ngFor="let plan of membershipPlans; let i = index; trackBy: trackByIndex">
              <div class="plan-name-header"
                   [style.color]="getHeadingColor()"
                   [title]="getPlanName(plan)">
                {{ getPlanName(plan) }}
              </div>
              <button class="purchase-button-small outlined"
                      [style.border-color]="getPrimaryColor()"
                      [style.color]="getPrimaryColor()"
                      [style.background-color]="'transparent'"
                      (click)="onBuyNowClick(plan, $event)">
                {{ getButtonLabel() }}
              </button>
            </div>
          </div>
        </div>
        
        <!-- Comparison Table -->
        <div class="comparison-table-wrapper" 
             [style.min-width]="'calc(300px + (200px * ' + membershipPlans.length + ') + (32px * ' + membershipPlans.length + '))'">
          <table class="comparison-table"
                 [style.min-width]="'calc(300px + (200px * ' + membershipPlans.length + ') + (32px * ' + membershipPlans.length + '))'">
            <thead>
              <tr class="table-header-row">
                <th class="feature-column"></th>
                <th class="plan-column" *ngFor="let plan of membershipPlans; trackBy: trackByIndex"></th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row" *ngFor="let feature of getComparisonFeatures(); trackBy: trackByIndex">
                <td class="feature-name"
                    [style.color]="getHeadingColor()"
                    [style.font-family]="getHeadingFont()"
                    [title]="feature.name">
                  {{ feature.name }}
                </td>
                <td class="feature-value" *ngFor="let plan of membershipPlans; trackBy: trackByIndex">
                  <div class="feature-cell-content">
                    <span *ngIf="getFeatureValue(plan, feature.key) === 'included'">
                      <svg class="check-icon-table" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#079271"/>
                        <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span *ngIf="getFeatureValue(plan, feature.key) === 'not_included'">
                      <svg class="minus-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#A7ABB3"/>
                        <path d="M8 12H16" stroke="white" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span *ngIf="getFeatureValue(plan, feature.key) !== 'included' && getFeatureValue(plan, feature.key) !== 'not_included'" 
                          class="feature-value-text"
                          [style.color]="getParagraphColor()"
                          [style.font-family]="getBodyFont()">
                      {{ getFeatureValue(plan, feature.key) }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>

  <!-- No Plans State -->
  <div *ngIf="!loading && !error && membershipPlans.length === 0" class="no-plans-state">
    <p>No membership plans available at the moment.</p>
  </div>

  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-champs-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [deviceType]="deviceType"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-champs-page-footer>
  </div>

  <!-- Package Selection Modal -->
  <app-shared-package-selection-modal
    [isVisible]="showPackageSelectionModal"
    [packages]="getPackagesForModal()"
    (close)="onClosePackageModal()"
    (packageSelected)="onPackageSelected($event)">
  </app-shared-package-selection-modal>
</div>
